/**
 * The room select's change handler, apart from React so the runner can execute it (#591).
 *
 * The room is read from the event NOW, never inside the way out handed to `leave`. When there is unsaved work,
 * `leave` holds that way out until somebody answers its question, and by then React has put the controlled select
 * back to the room still in force — so a way out reading `event.target.value` at Discard switched to the room it was
 * already in: the room stayed, the dialog stayed, and the guard's flag had been cleared underneath it.
 */
export function roomSelectChange(
  leave: (go: () => void) => void,
  setRoomId: (id: string) => void,
): (event: { target: { value: string } }) => void {
  return (event) => {
    const id = event.target.value;
    leave(() => setRoomId(id));
  };
}
